<template>
    <div>
        <v-row>
            <v-col cols="6" class="d-flex align-center">
                <v-switch
                    v-model="activatePayment"
                    label="Activer le paiement"
                    @change="showPayment()"
                    class="pa-0 pl-2"
                />
            </v-col>
            <!-- <v-col cols="6" class="d-flex align-center justify-end">
                    <v-btn
                        rounded
                        color="secondary"
                        elevation="0"
                         size="small"
                        @click="save()"
                        :disabled="!true"
                        class="mx-1"
                    >Sauvegarder</v-btn>
               </v-col> -->
        </v-row>

        <v-row no-gutters style="min-width: 800px">
            <div class="svg-container" id="container">
                <svg
                    width="100%"
                    height="100%"
                    class="svg-content"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <g />
                </svg>
            </div>
            <div id="paymentTooltip" style="visibility: hidden" class="divTooltip">
                <v-card class="default_card mx-0 my-2 pa-2" elevation="2">
                    <v-list>
                        <v-list-item
                            class="oss-list-item"
                            v-for="(item, index) in paymentItems"
                            :key="index"
                        >
                            <v-switch
                                v-model="links.payment"
                                :label="$t('workflow.nodes.' + item)"
                                @change="addEdge('payment', item)"
                                class="pa-0 pl-2"
                                :value="item"
                            />
                        </v-list-item>
                    </v-list>
                </v-card>
            </div>
            <div id="accValidTooltip" style="visibility: hidden" class="divTooltip">
                <v-card class="default_card mx-0 my-2 pa-2" elevation="2">
                    <v-list>
                        <v-list-item
                            class="oss-list-item"
                            v-for="(item, index) in accValidItems"
                            :key="index"
                        >
                            <v-switch
                                :disabled="!activatePayment"
                                v-model="links.accountingValidation"
                                :label="$t('workflow.nodes.' + item)"
                                @change="addEdge('accountingValidation', item)"
                                class="pa-0 pl-2"
                                :value="item"
                            />
                        </v-list-item>
                    </v-list>
                </v-card>
            </div>
            <div id="payValidTooltip" style="visibility: hidden" class="divTooltip">
                <v-card class="default_card mx-0 my-2 pa-2" elevation="2">
                    <v-list>
                        <v-list-item
                            class="oss-list-item"
                            v-for="(item, index) in payValidItems"
                            :key="index"
                        >
                            <v-switch
                                :disabled="!activatePayment"
                                v-model="links.paymentValidation"
                                :label="$t('workflow.nodes.' + item)"
                                @change="addEdge('paymentValidation', item)"
                                class="pa-0 pl-2"
                                :value="item"
                            />
                        </v-list-item>
                    </v-list>
                </v-card>
            </div>
        </v-row>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import * as d3 from "d3";
import dagreD3 from "dagre-d3";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {},
})
export class Workflow extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: "" }) companyId: string;

    scale = 0.9;
    visible = false;

    activatePayment = false;

    nodes = [];
    connections = [];
    links = {
        accountingValidation: [],
        paymentValidation: [],
        payment: [],
    };

    allNodes = [
        { id: "import" },
        { id: "analysis" },
        { id: "accountingValidation" },
        { id: "payment" },
        { id: "paymentValidation" },
        { id: "ibanValidation" },
    ];

    allConnections = [
        { id: "importToAnalysis", from: "import", to: "analysis" },
        { id: "analysisToAccountingValidation", from: "analysis", to: "accountingValidation" },
        { id: "importToPaymentValidation", from: "import", to: "paymentValidation" },
        { id: "analysisToPaymentValidation", from: "analysis", to: "paymentValidation" },
        {
            id: "accountingValidationToPaymentValidation",
            from: "accountingValidation",
            to: "paymentValidation",
        },
        { id: "accountingValidationToPayment", from: "accountingValidation", to: "payment" },
        {
            id: "paymentValidationToAccountingValidation",
            from: "paymentValidation",
            to: "accountingValidation",
        },
        { id: "paymentValidationToPayment", from: "paymentValidation", to: "payment" },
        {
            id: "ibanValidationToPaymentValidation",
            from: "ibanValidation",
            to: "paymentValidation",
        },
        { id: "ibanValidationToPayment", from: "ibanValidation", to: "payment" },
    ];

    paymentItems = ["accountingValidation", "paymentValidation", "ibanValidation"];
    payValidItems = ["import", "analysis"];
    accValidItems = ["paymentValidation"];

    async beforeMount() {
        // Sans cette requête, le flux de travail ne s'affiche pas correctement. La fonction rendering()
        // est appelée avant que le dialogue ne soit ouvert et lit donc une taille 0 lors du rendu du svg.
        await this.$apollo.query({
            query: gql`
                query ($id: ID!) {
                    profileCompany(where: { id: $id }) {
                        workflow
                    }
                }
            `,
            variables: {
                id: this.companyId,
            },
        });

        // debugger
        if (this.config?.workflow?.nodes?.length && this.config?.workflow?.connections?.length) {
            for (const node of this.config.workflow.nodes) {
                this.nodes.push(this.allNodes.find((n) => n.id === node.id));
            }
            this.activatePayment = this.nodes.length > 3 ? true : false;
            for (const connection of this.config.workflow.connections) {
                this.connections.push(this.allConnections.find((n) => n.id === connection.id));
                if (this.links[connection.to]) {
                    this.links[connection.to].push(connection.from);
                }
            }
        } else {
            this.nodes = this.allNodes.slice(0, 3);
            this.connections = this.allConnections.slice(0, 2);
            this.activatePayment = false;
        }
        this.rendering();
    }

    addEdge(end, start) {
        const edgeIndex = this.connections.findIndex((n) => n.from === start && n.to === end);
        if (this.links[end].includes(start)) {
            if (edgeIndex === -1) {
                this.connections.push(
                    this.allConnections.find((n) => n.from === start && n.to === end),
                );
            }
        } else {
            if (edgeIndex > -1) {
                this.connections.splice(edgeIndex, 1);
            }
        }
        this.addState(end);
        this.addState(start);
        this.save();
        this.rendering();
    }

    addState(state) {
        const nodeIndex = this.nodes.findIndex((n) => n.id === state);
        if (this.connections.filter((x) => x.to === state || x.from === state).length) {
            if (nodeIndex === -1) {
                this.nodes.push(this.allNodes.find((n) => n.id === state));
            }
        } else {
            if (state !== "payment" && nodeIndex > -1) {
                this.nodes.splice(nodeIndex, 1);
            }
        }
    }

    save() {
        this.config.workflow.nodes = this.nodes.map((node) => ({ id: node.id }));
        this.config.workflow.connections = this.connections.map((conn) => ({
            id: conn.id,
            to: conn.to,
            from: conn.from,
            conditions: { status: "" },
        }));
    }

    showPayment() {
        if (this.activatePayment) {
            this.nodes.push(this.allNodes.find((n) => n.id === "payment"));
        } else {
            this.nodes = [
                { id: "import", label: "Import" },
                { id: "analysis", label: "Analyse bobbee" },
                { id: "accountingValidation", label: "Validation Comptable" },
            ];
            this.connections = [
                { id: "importToAnalysis", from: "import", to: "analysis", label: "import terminé" },
                {
                    id: "analysisToAccountingValidation",
                    from: "analysis",
                    to: "accountingValidation",
                    label: "analyse terminé",
                },
            ];
            for (const key in this.links) {
                this.links[key].length = 0;
            }
        }
        this.rendering();
    }

    rendering() {
        const self = this;
        const graph = new dagreD3.graphlib.Graph().setGraph({});

        this.nodes.forEach((node) => {
            const edges = this.connections.filter((n) => n.from === node.id).map((n) => n.to);
            graph.setNode(node.id, {
                label: this.$t("workflow.nodes." + node.id),
                edge: edges,
                labelStyle: "font-size: 1.3em",
            });
            if (node.id.indexOf("error") === -1) {
                graph.node(node.id).style = "fill: #e6e4e4";
            } else {
                graph.node(node.id).style = "fill: #f77";
            }
        });

        this.connections.forEach(function (edge) {
            // graph.setEdge(edge.from, edge.to, { label: edge.label, labelStyle: "font-style: italic; font-size: 0.9em;" });
            graph.setEdge(edge.from, edge.to, {
                label: self.$t("workflow.connections." + edge.id),
                labelStyle: "font-style: italic; font-size: 0.9em;",
                curve: d3.curveBasis,
            });
        });

        graph.graph().rankdir = "LR"; // left to right
        graph.graph().nodesep = 30; // distance between nodes

        graph.nodes().forEach(function (v) {
            const node = graph.node(v);
            node.rx = node.ry = 5; //corner radius
        });

        const svg = d3.select("div#container").select("svg"),
            inner = svg.select("g");

        const render = new dagreD3.render();
        render(inner, graph);

        // Center graph
        inner.attr("transform", `translate(0, 0) scale(1)`);
        const svgWidth = document
            .getElementById("container")
            .firstElementChild.getBoundingClientRect().width;
        const gWidth = document
            .getElementById("container")
            .firstElementChild.firstElementChild.getBoundingClientRect().width;
        // const svgHeight = document
        //     .getElementById("container")
        //     .firstElementChild.getBoundingClientRect().height;
        // const gHeight = document
        //     .getElementById("container")
        //     .firstElementChild.firstElementChild.getBoundingClientRect().height;

        // const scale = Math.min(svgWidth / gWidth, svgHeight / gHeight);
        this.scale = svgWidth / gWidth - 0.01;

        const translateX = 5;
        const translateY = 15;
        // const translateY = (svgHeight - gHeight * scale) / 2;

        inner.attr("transform", `translate(${translateX}, ${translateY}) scale(${this.scale})`);

        const paymentTooltip = d3.select("div#paymentTooltip").on("mouseleave", () => {
            if (document.getElementById("paymentTooltip").style.visibility === "visible") {
                paymentTooltip.style("visibility", "hidden");
                self.visible = false;
            }
        });

        const accValidTooltip = d3.select("div#accValidTooltip").on("mouseleave", () => {
            if (document.getElementById("accValidTooltip").style.visibility === "visible") {
                accValidTooltip.style("visibility", "hidden");
                self.visible = false;
            }
        });

        const payValidTooltip = d3.select("div#payValidTooltip").on("mouseleave", () => {
            if (document.getElementById("payValidTooltip").style.visibility === "visible") {
                payValidTooltip.style("visibility", "hidden");
                self.visible = false;
            }
        });

        svg.selectAll("g.node")
            .on("click", function (d) {
                if (d === "payment") {
                    paymentTooltip
                        .style("visibility", "visible")
                        .style(
                            "top",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[1] +
                                document
                                    .getElementById("paymentTooltip")
                                    .firstElementChild.firstElementChild.getBoundingClientRect()
                                    .height /
                                    2 +
                                "px",
                        )
                        .style(
                            "left",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[0] -
                                (self.links.payment.length ? 280 : 0) +
                                "px",
                        );
                    self.visible = true;
                } else if (d === "paymentValidation") {
                    payValidTooltip
                        .style("visibility", "visible")
                        .style(
                            "top",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[1] +
                                document
                                    .getElementById("payValidTooltip")
                                    .firstElementChild.firstElementChild.getBoundingClientRect()
                                    .height /
                                    2 +
                                "px",
                        )
                        .style(
                            "left",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[0] -
                                (self.scale < 0.78 || this.getBoundingClientRect().x > 500
                                    ? 200
                                    : 0) +
                                "px",
                        );
                    self.visible = true;
                } else if (d === "accountingValidation") {
                    accValidTooltip
                        .style("visibility", "visible")
                        .style(
                            "top",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[1] +
                                60 +
                                document
                                    .getElementById("accValidTooltip")
                                    .firstElementChild.firstElementChild.getBoundingClientRect()
                                    .height +
                                "px",
                        )
                        .style(
                            "left",
                            d3.mouse(
                                this.parentElement.parentElement.parentElement.parentElement,
                            )[0] -
                                (self.links.payment.length || this.getBoundingClientRect().x > 500
                                    ? 0
                                    : 280) +
                                "px",
                        );
                    self.visible = true;
                }
            })
            .on("mouseover", function (d) {
                self.highlightEdges(d);
                if (["accountingValidation", "paymentValidation", "payment"].includes(d)) {
                    d3.select(this).style("cursor", "pointer");
                }
            })
            .on("mouseleave", () => {
                d3.selectAll("rect.label-container").style("fill", "#e6e4e4");
            })
            .selectAll("rect.label-container")
            .on("mouseover", function (d) {
                if (d === "payment" || d === "paymentValidation" || d === "accountingValidation") {
                    d3.select(this).style("fill", "#b1afaf");
                } else {
                    d3.select(this).style("fill", "e6e4e4");
                }
            })
            .on("mouseleave", function () {
                d3.select(this).style("fill", "#e6e4e4");
            });

        const gHeigth = document
            .getElementById("container")
            .firstElementChild.firstElementChild.getBoundingClientRect().height;
        svg.attr("height", gHeigth + 100);
    }

    highlightEdges(d) {
        const children = this.connections.filter((n) => n.from === d).map((n) => n.to);
        const parents = this.connections.filter((n) => n.to === d).map((n) => n.from);
        if (children.length > 0) {
            d3.select("div#container")
                .select("svg")
                .select("g.nodes")
                .selectAll("g.node")
                .filter(function (d) {
                    return children.includes(d);
                })
                .select("rect.label-container")
                .style("fill", "#5FC9B8");
        }
        if (parents.length > 0) {
            d3.select("div#container")
                .select("svg")
                .select("g")
                .selectAll("g.node")
                .filter(function (d) {
                    return parents.includes(d);
                })
                .select("rect.label-container")
                .style("fill", "#F9B12A");
        }
        // const circulardp = children.filter(element => parents.includes(element));
        // if (circulardp.length > 0) {
        //     d3.select("svg")
        //     .select("g")
        //     .selectAll("g.node")
        //     .filter(function(d) {
        //         return circulardp.includes(d);
        //     })
        //     .select("rect.label-container")
        //     .style("fill", "gold");
        // }
    }
}

export default toNative(Workflow);
</script>

<style lang="scss">
.svg-container {
    display: inline-block;
    position: relative;
    width: 100%;
    /* padding-bottom: 100%; */
    vertical-align: top;
    overflow: hidden;
}
.svg-content {
    display: block;
    margin: auto;
    border: 0px solid #ccc;
    padding-top: 10px;
}

.node text {
    pointer-events: none;
}
.node rect {
    stroke: #333;
    fill: #fff;
}

.divTooltip {
    position: absolute;
    //background-color: white;
    //   border: 0.5px solid;
    //   border-color:rgb(182, 177, 177);
    //   border-radius: 5px;
    padding: 0px;
    z-index: 10;
    visibility: hidden;
}

.edgePath path {
    stroke: #333;
    fill: #333;
    stroke-width: 1.5px;
}

.dashedLine {
    stroke-dasharray: 5, 5;
    stroke: #555353;
}
</style>
